import {Amplify} from 'aws-amplify';
import {AuthService} from './AuthService';
import * as $ from "jquery";
import {jwtDecode, JwtDecodeOptions} from "jwt-decode";

const isLive = window.location.hostname.includes('garforthgray.im');

let amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: "eu-west-1_VnifhosEN",  // DEV pool ID
      userPoolClientId: "34n5j32inrisin7ovkkji069uq"    // DEV client ID
    }
  }
};

if (isLive) {
  amplifyConfig = {
    Auth: {
      Cognito: {
        userPoolId: "eu-west-1_HUFGn7PLY",  // LIVE pool ID
        userPoolClientId: "4tn5nccl5ebu8a157nhjsp7b2t"   // LIVE client ID
      }
    }
  };
}
Amplify.configure(amplifyConfig);

const currentConfig = Amplify.getConfig();
const authService = new AuthService();

$(function (token: string, options: JwtDecodeOptions & { header: true }) {

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  function changeStep(step: string, opts: { redirect?: string, delay?: number } = {redirect: '', delay: 0}) {
    $('.step').hide();
    $(`#${step}`).show();
    hideLoader();

    if (opts.redirect) {
      setTimeout(function () {
        window.location.href = <string>opts.redirect;
      }, opts.delay);
    }
  }

  function showError(error: string) {
    const $errorContainer = $(`.errorContainer`);
    const $errorText = $errorContainer.find('.errorText');
    $errorText.text(error);
    $errorContainer.show();
  }


  function hideError() {
    let $errorContainer = $('#errorContainer');
    $errorContainer.hide();
  }

  function showLoader($form: any) {
    // add loader to form
    $form.append('<div id="loader" class="loader"></div>');
  }

  function hideLoader() {
    // remove loader from form
    $('#loader').remove();
  }

  $('#loginForm').on('submit', function (e) {
    e.preventDefault();
    hideError();
    showLoader($(this));
    const authService = new AuthService();

    let email: any = $('#email').val();

    authService.signIn(email).then(function (response) {

      if (response === 'custom_challenge') {

        changeStep('confirmCodeStep');

      }
      else {

        if (response === 'NoExistingUser') {

          authService.signUp(email).then(function (response) {

            if (response === true) {
              authService.signIn(email).then(function (response) {
                if (response === 'custom_challenge') {
                  changeStep('confirmCodeStep');
                  return;
                }
                else {
                  handleError(response);
                }
              });
            }
            else {
              handleError(response);
            }

          });
        }
        else {
          handleError(response);
        }
      }
    });
  });

  function handleError(error: any) {

    hideLoader();

    if (error.message) {
      let message = error.message;

      //  matches "FunctionName failed with error"
      let lambdaErrorPattern = /\w+\sfailed\swith\serror\s/;
      if (lambdaErrorPattern.test(error.message)) {
        message = message.replace(lambdaErrorPattern, '');
      }

      showError(message);

    }
    else {
      showError('There was an error signing in. Please try again or contact support.');
    }

  }

  $('#confirmForm').on('submit', function (e) {
    e.preventDefault();
    hideError();

    const code: any = $('#code').val();
    authService.answerCustomChallenge(code).then(function (response) {

      if (response === 'isSignedIn') {
        completeLogin();
      } else if (response.attempts < response.maxAttempts) {
        showError('The code is not correct, please try again.');
      } else if (response.attempts >= response.maxAttempts) {
        showError('You have entered too many attempts, please try again');
        window.location.href = '/auth/';
      } else {
        showError('There was an error logging in, please contact us for assistance');
      }
    });

  });

  $('#logOutButton').on('click', function() {
    hideError();
    completeLogout();
  });

  function completeLogin() {

    authService.getIDToken().then((token) => {

      const idToken = <string>token?.toString();

      $.post('../dashboard/set_auth.php', {'id_token': idToken}, function(data) {
        let redirectUrl = urlParams.get('state') || '/';
        changeStep('loggedInStep', {redirect: redirectUrl});
      });

    });

  }

  function completeLogout() {
    authService.signOut().then(function() {
      $.post('../dashboard/logout.php', {}, function(data) {
        let redirectUrl = urlParams.get('state') || '/';
        changeStep('loggedOutStep', {redirect: redirectUrl});
      });
    });
  }

  if (urlParams.has('logout')) {
    completeLogout();
  }
  else {
    authService.isAuthenticated().then((isAuthenticated) => {
      if (isAuthenticated) {
        completeLogin();
      } else {
        changeStep('loginStep');
      }
    });
  }


});
